import React, { useState, useEffect } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import SearchBar from "../../../../components/SearchBar";
import Pagination from "../../../../components/Pagination";
import ExportToExcel from "../../../../components/ExportToExcel";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";

const MyProject = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [myProjectData, setMyProjectData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const navigate = useNavigate();
  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );
  // Define all columns with their display text and initial visibility
  const [columns, setColumns] = useState({
    project: { text: "Project", visible: true },
    client: { text: "Client", visible: true },
    location: { text: "Location", visible: true },
    role: { text: "Role", visible: true },
    startDate: { text: "Start Date", visible: true },
    endDate: { text: "End Date", visible: true },
    projectType: { text: "Project Type", visible: true },
    progress: { text: "Progress (%)", visible: true },
    action: { text: "Action", visible: true },
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("My Projects"));
  }, []);

  useEffect(() => {
    fetchProjectData();
  }, []);

  const fetchProjectData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}myproject`);
      SetApiStatus(response?.status);

      if (response.status === 200) {
        SetApiStatus(response?.status);
        const projectData = response?.data?.data;
        setMyProjectData(projectData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch My Project. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Project:", error);
    }
  };

  // Filter data based on search term
  const filteredData = myProjectData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Get current items for pagination
  const indexOfLastItem = currentPage * selectedRecordsPerPage;
  const indexOfFirstItem = indexOfLastItem - selectedRecordsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Function to toggle column visibility
  const toggleColumn = (columnKey) => {
    setColumns((prev) => ({
      ...prev,
      [columnKey]: {
        ...prev[columnKey],
        visible: !prev[columnKey].visible,
      },
    }));
  };

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setSelectedRecordsPerPage(newRecordsPerPage);
    setItemsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const handleEdit = (id) => {
    console.log("item id received:", id);
    // navigate(`/my-task/edit/${id}`);
    navigate(`/my-task`);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
          <div className="d-flex justify-content-between">
            <div className="me-1">
              <SearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>

            <div className="d-flex justify-content-end">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
              >
                <div className="me-1">
                  <ExportToExcel
                    data={currentItems.map((item) => {
                      const visibleItem = {};
                      if (columns.project.visible)
                        visibleItem["Project"] = item.Name || "";
                      if (columns.client.visible)
                        visibleItem["Client"] = item.ClientName || "";
                      if (columns.location.visible)
                        visibleItem["Location"] = item.Location || "";
                      if (columns.role.visible)
                        visibleItem["Role"] = item.Role || "";
                      if (columns.startDate.visible)
                        visibleItem["Start Date"] = item.StartDate || "";
                      if (columns.endDate.visible)
                        visibleItem["End Date"] = item.EndDate || "";
                      if (columns.projectType.visible)
                        visibleItem["Project Type"] = item.ProjectType || "";
                      if (columns.progress.visible)
                        visibleItem["Progress (%)"] = item.Progress || "0%";
                      return visibleItem;
                    })}
                    filename={`${ExcelName}.csv`}
                  />
                </div>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
              >
                <div className="btn-group me-2">
                  <button
                    type="button"
                    className="dropdown-toggle skill-button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    id="excel-btn"
                  >
                    <i className="bi bi-list"></i>
                  </button>
                  <ul className="dropdown-menu p-2">
                    <div className="row">
                      <Form.Group>
                        {Object.keys(columns).map((columnKey) => (
                          <Form.Check
                            key={columnKey}
                            type="checkbox"
                            id={`checkbox-${columnKey}`}
                            label={columns[columnKey].text}
                            checked={columns[columnKey].visible}
                            onChange={() => toggleColumn(columnKey)}
                          />
                        ))}
                      </Form.Group>
                    </div>
                  </ul>
                </div>
              </OverlayTrigger>
            </div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table bordered striped hover>
              <thead id="thcolor">
                <tr className="text-center">
                  {columns.project.visible && <th>Project</th>}
                  {columns.client.visible && <th>Client</th>}
                  {columns.location.visible && <th>Location</th>}
                  {columns.role.visible && <th>Role</th>}
                  {columns.startDate.visible && <th>Start Date</th>}
                  {columns.endDate.visible && <th>End Date</th>}
                  {columns.projectType.visible && <th>Project Type</th>}
                  {columns.progress.visible && <th>Progress (%)</th>}
                  {columns.action.visible && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {currentItems.length != 0 && apiStatus === 200 ? (
                  currentItems.map((item, index) => {
                    console.log("Item:", item);

                    return (
                      <tr key={index}>
                        {columns.project.visible && <td>{item.Name || "-"}</td>}
                        {columns.client.visible && (
                          <td>{item.ClientName || "-"}</td>
                        )}
                        {columns.location.visible && (
                          <td>{item.Location || "-"}</td>
                        )}
                        {columns.role.visible && <td>{item.Role || "-"}</td>}
                        {columns.startDate.visible && (
                          <td
                            style={{ width: "120px" }}
                            className="text-center"
                          >
                            {item.StartDate
                              ? moment(item.StartDate).format("DD-MMM-YYYY")
                              : "-"}
                          </td>
                        )}
                        {columns.endDate.visible && (
                          <td
                            style={{ width: "120px" }}
                            className="text-center"
                          >
                            {item.EndDate
                              ? moment(item.EndDate).format("DD-MMM-YYYY")
                              : "-"}
                          </td>
                        )}
                        {columns.projectType.visible && (
                          <td>{item.ProjectType || "-"}</td>
                        )}
                        {columns.progress.visible && (
                          <td style={{ minWidth: "150px" }}>
                            <div
                              className="progress position-relative"
                              style={{ height: "25px" }}
                            >
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${item.Progress || 0}%` }}
                                aria-valuenow={item.Progress || 0}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                              <span
                                className="position-absolute w-100 text-center"
                                style={{
                                  top: "50%",
                                  left: "0",
                                  transform: "translateY(-50%)",
                                  fontWeight: "bold",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {item.Progress || 0}%
                              </span>
                            </div>
                          </td>
                        )}
                        {columns.action.visible && (
                          <td className="text-center">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-edit-${item.ID}`}>
                                  My Task
                                </Tooltip>
                              }
                            >
                              <i
                                class="bi bi-card-list icons"
                                onClick={() => handleEdit(item.ID)}
                                style={{ cursor: "pointer" }}
                              ></i>
                            </OverlayTrigger>
                          </td>
                        )}
                      </tr>
                    );
                  })
                ) : currentItems.length === 0 && apiStatus === 200 ? (
                  <tr>
                    <td
                      colSpan={
                        Object.values(columns).filter((col) => col.visible)
                          .length
                      }
                      className="text-center text-muted"
                    >
                      No Data Found
                    </td>
                  </tr>
                ) : currentItems.length === 0 && apiStatus === undefined ? (
                  <tr>
                    <td colSpan={9} className="text-center">
                      <div>
                        <p>
                          <FaSpinner class="spinner" />
                          <br />
                          Loading
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td
                      colSpan={
                        Object.values(columns).filter((col) => col.visible)
                          .length
                      }
                      className="text-center text-muted"
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3">
            {/* Text and per-page dropdown - stacked on mobile, inline on sm+ */}
            <div className="d-flex justify-content-between px-2">
              <span style={{ width: "150px" }}>
                Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
                {Math.min(
                  currentPage * selectedRecordsPerPage,
                  filteredData.length
                )}{" "}
                of {filteredData.length}
              </span>

              <div style={{ width: "80px" }}>
                <select
                  value={selectedRecordsPerPage}
                  onChange={handleRecordsPerPage}
                  className="form-select form-select-sm ms-2"
                >
                  {recordsPerPageOption.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Pagination - centered on mobile, right-aligned on sm+ */}
            <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
              <Pagination
                itemsPerPage={selectedRecordsPerPage}
                totalItems={filteredData.length}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyProject;
